// extracted by mini-css-extract-plugin
export default {"square":"Square_square__1L3wd","selected":"Square_selected__ZZglt","highlight":"Square_highlight__CvdbR","cuts":"Square_cuts__gwr14"};